<template>
  <v-card height="100%" width="100%" flat>
    <v-row no-gutters justify="center" align="center" class="flex-column">
      <span
        class="cardTitle mt-6"
        v-html="$t('message.pages.firstLoading.loadingText')"
      />
    </v-row>
  </v-card>
</template>

<script>
import videosApi from '../../services/videosApi'
import planApi from '../../services/planApi'

export default {
  name: 'FirstLoading',
  data: () => ({
    defaultOptions: { animationData: {} },
    animationSpeed: 1,
    alreadyCreated: false,
    planAmount: 0,
    currency: 'brl',
  }),
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },
    stop: function () {
      this.anim.stop()
    },
    play: function () {
      this.anim.play()
    },
    pause: function () {
      this.anim.pause()
    },
    async verifyAccount() {
      if (this.alreadyCreated) {
        this.$router.push({ name: 'Videos' })
      } else {
        const subscription = await this.checkStripe()
        if ((await this.checkLibrary()) && subscription) {
          this.alreadyCreated = true
          try {
            this.planAmount = subscription.data.subscriptions.unit_amount / 100
            this.currency = subscription.data.currency
          } catch {
            this.planAmount = 0
          }
          this.verifyAccount()
        } else {
          setTimeout(() => {
            this.verifyAccount()
          }, 2000)
        }
      }
    },
    async checkLibrary() {
      try {
        await videosApi.getVideos()
        return true
      } catch (e) {
        return false
      }
    },
    async checkStripe() {
      try {
        return await planApi.getSubscription()
      } catch (e) {
        return false
      }
    },
  },
  async created() {
    this.verifyAccount()
  },
}
</script>

<style scoped>
.cardTitle {
  font-weight: 500;
  font-size: 20px;
  color: #555;
  text-align: center;
  line-height: 1.7;
}
</style>
